import React from 'react';
import { BookOpenIcon, CalendarIcon, CheckCircleIcon, ClockIcon, MapPinIcon } from 'lucide-react';
export const WebinarDetails = () => {
  return <section className="mb-10" data-id="element-186">
      <h2 className="text-xl font-bold text-blue-800 mb-4 flex items-center" data-id="element-187">
        <BookOpenIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-188" />
        Wat Je Gaat Leren In Dit GRATIS Webinar
      </h2>
      <div className="bg-blue-50 p-5 rounded-lg mb-8 border border-blue-200" data-id="element-189">
        <div className="flex flex-col md:flex-row md:items-center mb-4" data-id="element-190">
          <div className="flex items-center mb-2 md:mb-0 md:mr-6" data-id="element-191">
            <CalendarIcon className="w-5 h-5 text-blue-600 mr-2" data-id="element-192" />
            <span className="font-semibold" data-id="element-193">Vandaag of morgen</span>
          </div>
          <div className="flex items-center mb-2 md:mb-0 md:mr-6" data-id="element-194">
            <ClockIcon className="w-5 h-5 text-blue-600 mr-2" data-id="element-195" />
            <span className="font-semibold" data-id="element-196">10:00, 13:00 of 20:00 uur</span>
          </div>
          <div className="flex items-center" data-id="element-197">
            <MapPinIcon className="w-5 h-5 text-blue-600 mr-2" data-id="element-198" />
            <span className="font-semibold" data-id="element-199">Online (vanuit je eigen huis)</span>
          </div>
        </div>
        <p className="text-sm text-blue-800" data-id="element-200">
          Plaatsen zijn beperkt tot 75 deelnemers. Schrijf je nu in om je plek
          te reserveren!
        </p>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-201">
        In plaats van je hond te dwingen om jouw regels te volgen, leer je in
        dit webinar de grammatica en woordenschat van de hondentaal. Je ontdekt
        hoe je kunt communiceren op een manier die je hond natuurlijk begrijpt.
      </p>
      <div className="w-full mb-6" data-id="element-202">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/adfEt27Jye6FQiTqbD9WSK/Scherm%C2%ADafbeelding_2025-08-15_om_15.38.32.png" alt="Hond en eigenaar communiceren met handgebaren" className="w-full h-auto rounded-lg shadow-md" data-id="element-203" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-204">
          Handgebaren zijn 99% effectief en vormen een belangrijk onderdeel van
          de hondentaal
        </p>
      </div>
      <p className="mb-8 leading-relaxed" data-id="element-205">
        Je leert niet alleen dat je de signalen van je hond kan lezen, maar ook
        dat je kunt terugpraat op een manier die je hond van nature begrijpt.
        Het mooie is dat deze taal helemaal niet moeilijk is. Honden
        communiceren heel direct en eerlijk. Het is alleen anders dan wat wij
        gewend zijn (met je lichaam, en niet met je stem).
      </p>
      <h3 className="text-lg font-bold text-blue-800 mb-4" data-id="element-206">
        Tijdens dit webinar ontdek je:
      </h3>
      <div className="space-y-4 mb-8" data-id="element-207">
        <div className="flex items-start" data-id="element-208">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-209" />
          <div data-id="element-210">
            <h4 className="font-bold" data-id="element-211">
              De 3 meest gemaakte communicatiefouten
            </h4>
            <p className="text-gray-700" data-id="element-212">
              Ontdek waarom veel baasjes onbedoeld verwarring veroorzaken en hoe
              je dit direct kunt verbeteren.
            </p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-213">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-214" />
          <div data-id="element-215">
            <h4 className="font-bold" data-id="element-216">
              De geheime taal van kalmerende signalen
            </h4>
            <p className="text-gray-700" data-id="element-217">
              Leer de subtiele lichaamstaal herkennen waarmee je hond de hele
              dag communiceert, maar die de meeste mensen missen.
            </p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-218">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-219" />
          <div data-id="element-220">
            <h4 className="font-bold" data-id="element-221">
              Het attentiesignaal dat direct resultaat geeft
            </h4>
            <p className="text-gray-700" data-id="element-222">
              Een simpele techniek om de aandacht van je hond te krijgen, zelfs
              in afleidende situaties.
            </p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-223">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-224" />
          <div data-id="element-225">
            <h4 className="font-bold" data-id="element-226">
              Hoe je stress bij je hond kunt herkennen én verminderen
            </h4>
            <p className="text-gray-700" data-id="element-227">
              Praktische tips om rustige wandelingen te hebben en probleemgedrag
              te verminderen.
            </p>
          </div>
        </div>
      </div>
      <div className="w-full mb-6" data-id="element-228">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5cB7x4JBKLA2SGnQ1mna3u/Scherm%C2%ADafbeelding_2025-08-15_om_15.46.41.png" alt="Vrouw wandelt ontspannen met haar hond op een bospad in de namiddagzon" className="w-full h-auto rounded-lg shadow-md" data-id="element-229" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-230">
          Een stressvrij leven voor je hond. En voor jou.
        </p>
      </div>
      <div className="bg-green-50 p-6 rounded-lg border border-green-200 mb-8" data-id="element-231">
        <h3 className="text-lg font-bold text-green-800 mb-4" data-id="element-232">
          Speciale Bonus Voor Alle Deelnemers:
        </h3>
        <ul className="space-y-3 mb-4" data-id="element-233">
          <li className="flex items-start" data-id="element-234">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-235" />
            <span data-id="element-236">
              Gratis downloadbaar werkboek "De Basis van de Hondentaal"
            </span>
          </li>
          <li className="flex items-start" data-id="element-237">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-238" />
            <span data-id="element-239">Toegang tot de webinar-opname voor 48 uur na afloop</span>
          </li>
          <li className="flex items-start" data-id="element-240">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-241" />
            <span data-id="element-242">Exclusieve Q&A-sessie na afloop van het webinar</span>
          </li>
        </ul>
        <div className="bg-white p-4 rounded-lg border border-green-200" data-id="element-243">
          <p className="font-bold text-green-800 mb-2" data-id="element-244">Belangrijk:</p>
          <p className="text-green-800" data-id="element-245">
            Dit webinar is VOLLEDIG GRATIS en verplicht je tot niets. Ik wil
            simpelweg deze waardevolle kennis delen met zoveel mogelijk
            hondenbaasjes, omdat ik geloof dat elk baasje en elke hond recht
            heeft op een harmonieuze relatie.
          </p>
        </div>
      </div>
    </section>;
};